/** Ghana Post GPS full address codes (not district-only admin codes). */

/** Old: AK-039-5028 (11). New: GH-GA141-2554 (15). */
export const GHANA_POST_GPS_MAX_LENGTH = 15;

export const GHANA_POST_GPS_FULL_REGEX =
  /^(?:GH-[A-Z]{2}\d{3}|[A-Z]{2}-\d{3})-\d{4}$/;

export function sanitizeGhanaPostGpsInput(raw: string): string {
  return raw
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '')
    .slice(0, GHANA_POST_GPS_MAX_LENGTH);
}

export function isValidFullGhanaPostGps(value: string): boolean {
  return GHANA_POST_GPS_FULL_REGEX.test(value.trim().toUpperCase());
}
